// Chakra Imports
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Heading,
  HStack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import AdminNavbarLinks from "./AdminNavbarLinks";
import { FaMicroscope } from "react-icons/fa";

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const {
    variant,
    children,
    fixed,
    secondary,
    brandText,
    onOpen,
    ...rest
  } = props;

  let mainText = useColorModeValue("slate.800", "white");
  let secondaryText = useColorModeValue("slate.500", "slate.400");

  const navbarBg = useColorModeValue(
    "rgba(255, 255, 255, 0.8)",
    "rgba(11, 19, 41, 0.8)"
  );
  const navbarBorder = useColorModeValue(
    "1px solid rgba(226, 232, 240, 0.8)",
    "1px solid rgba(255, 255, 255, 0.08)"
  );
  const navbarShadow = useColorModeValue(
    "0 10px 30px rgba(15, 23, 42, 0.06)",
    "0 10px 30px rgba(0, 0, 0, 0.3)"
  );

  useEffect(() => {
    const changeNavbar = () => {
      if (window.scrollY > 1) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", changeNavbar);
    return () => window.removeEventListener("scroll", changeNavbar);
  }, []);

  return (
    <Flex
      position="fixed"
      top={{ base: "0", xl: "16px" }}
      left={{ base: "0", xl: "295px" }}
      right={{ base: "0", xl: "20px" }}
      w={{ base: "100%", xl: "auto" }}
      boxShadow={navbarShadow}
      bg={navbarBg}
      border={{ base: "none", xl: navbarBorder }}
      borderBottom={navbarBorder}
      backdropFilter="blur(20px)"
      transition="all 0.25s cubic-bezier(0.4, 0, 0.2, 1)"
      alignItems="center"
      borderRadius={{ base: "0", xl: "24px" }}
      minH={{ base: "58px", xl: "70px" }}
      justifyContent="space-between"
      px={{ base: "14px", sm: "20px", md: "24px", xl: "24px" }}
      py="0"
      zIndex="1000"
    >
      {/* Page Title & Breadcrumbs */}
      <Box minW="0" flex="1" mr={{ base: "8px", sm: "16px" }}>
        <Breadcrumb mb="2px" display={{ base: "none", md: "block" }}>
          <BreadcrumbItem color={secondaryText} fontSize="xs" fontWeight="500">
            <BreadcrumbLink href="#" color={secondaryText}>
              Dashboard
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem color={mainText} fontSize="xs" fontWeight="700">
            <BreadcrumbLink href="#" color="teal.500">
              {brandText}
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <Heading
          as="h1"
          fontSize={{ base: "sm", sm: "md", md: "lg" }}
          color={mainText}
          fontWeight="800"
          letterSpacing="-0.02em"
          noOfLines={1}
          lineHeight="1.2"
        >
          {brandText}
        </Heading>
      </Box>

      {/* Navbar Action Icons & Links */}
      <Box ms="auto" flexShrink="0">
        <AdminNavbarLinks
          onOpen={props.onOpen}
          logoText={props.logoText}
          secondary={props.secondary}
          fixed={props.fixed}
        />
      </Box>
    </Flex>
  );
}

AdminNavbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};

